import React from 'react';
import styles from './Footer.module.css';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={`${styles.content} reveal`}>
          <a 
            href="/" 
            className={styles.logo}
            aria-label="Ana Home"
          >
            <img src="/ANA Logo (1).png" alt="Ana Logo" />
          </a>
          
          <div className={styles.divider}></div>
          
          <div className={styles.info}>
            <p className={styles.contact}>
              Drop a note at{' '}
              <a 
                href="mailto:hello@openana.ai" 
                className={styles.email}
                target="_blank"
                rel="noopener noreferrer"
              >
                hello@openana.ai
              </a>
            </p>
            <p className={styles.copyright}>
              © {currentYear} Ana is copyright of OpenAna. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
